import React from 'react';

interface ImageSectionProps {
  imageUrl: string;
  title: string;
  description: string;
  reverse?: boolean;
}

export default function ImageSection({ imageUrl, title, description, reverse = false }: ImageSectionProps) {
  return (
    <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 mb-16`}>
      <div className="w-full md:w-1/2">
        <div className="relative group overflow-hidden rounded-lg">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-[400px] object-cover transform transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-[--c-main]/10 transition-opacity duration-300 opacity-0 group-hover:opacity-100" />
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <h2 className="text-3xl font-bold text-[--c-dark] mb-4">{title}</h2>
        <p className="text-main text-xl leading-relaxed">{description}</p>
      </div>
    </div>
  );
}